import _ from 'lodash';

export interface XPLevelInfo {
  level: number;
  title: string;
  icon: string;
  xpGainedInLevel: number;
  xpLeftToNextLevel: number;
  xpRequiredForNextLevel: number;
  progressInLevel: number;
}

export interface XPLevelDefinition {
  level: number;
  requiredXP: number;
  title: string;
  icon: string;
}

export const XP_LEVEL_DEFINITIONS: XPLevelDefinition[] = [
  {
    level: 0,
    requiredXP: 0,
    title: 'Newbie Reader',
    icon: require('../assets/xp/lvl-group-1.png'),
  },
  {
    level: 1,
    requiredXP: 60,
    title: 'Novice Reader',
    icon: require('../assets/xp/lvl-group-1.png'),
  },
  {
    level: 2,
    requiredXP: 80,
    title: 'Book Explorer',
    icon: require('../assets/xp/lvl-group-1.png'),
  },
  {
    level: 3,
    requiredXP: 100,
    title: 'Growing Reader',
    icon: require('../assets/xp/lvl-group-1.png'),
  },
  {
    level: 4,
    requiredXP: 140,
    title: 'Steady Reader',
    icon: require('../assets/xp/lvl-group-1.png'),
  },
  {
    level: 5,
    requiredXP: 180,
    title: 'Reading Enthusiast',
    icon: require('../assets/xp/lvl-group-2.png'),
  },
  {
    level: 6,
    requiredXP: 240,
    title: 'Book Adventurer',
    icon: require('../assets/xp/lvl-group-2.png'),
  },
  {
    level: 7,
    requiredXP: 300,
    title: 'Story Seeker',
    icon: require('../assets/xp/lvl-group-2.png'),
  },
  {
    level: 8,
    requiredXP: 380,
    title: 'Page Turner',
    icon: require('../assets/xp/lvl-group-2.png'),
  },
  {
    level: 9,
    requiredXP: 460,
    title: 'Chapter Champion',
    icon: require('../assets/xp/lvl-group-2.png'),
  },
  {
    level: 10,
    requiredXP: 560,
    title: 'Book Voyager',
    icon: require('../assets/xp/lvl-group-3.png'),
  },
  {
    level: 11,
    requiredXP: 680,
    title: 'Reading Explorer',
    icon: require('../assets/xp/lvl-group-3.png'),
  },
  {
    level: 12,
    requiredXP: 820,
    title: 'Story Collector',
    icon: require('../assets/xp/lvl-group-3.png'),
  },
  {
    level: 13,
    requiredXP: 1000,
    title: 'Book Enthusiast',
    icon: require('../assets/xp/lvl-group-3.png'),
  },
  {
    level: 14,
    requiredXP: 1200,
    title: 'Reading Pioneer',
    icon: require('../assets/xp/lvl-group-3.png'),
  },
  {
    level: 15,
    requiredXP: 1440,
    title: 'Literature Lover',
    icon: require('../assets/xp/lvl-group-4.png'),
  },
  {
    level: 16,
    requiredXP: 1700,
    title: 'Book Connoisseur',
    icon: require('../assets/xp/lvl-group-4.png'),
  },
  {
    level: 17,
    requiredXP: 2000,
    title: 'Reading Devotee',
    icon: require('../assets/xp/lvl-group-4.png'),
  },
  {
    level: 18,
    requiredXP: 2400,
    title: 'Story Master',
    icon: require('../assets/xp/lvl-group-4.png'),
  },
  {
    level: 19,
    requiredXP: 2800,
    title: 'Book Scholar',
    icon: require('../assets/xp/lvl-group-4.png'),
  },
  {
    level: 20,
    requiredXP: 3200,
    title: 'Reading Virtuoso',
    icon: require('../assets/xp/lvl-group-5.png'),
  },
  {
    level: 21,
    requiredXP: 3700,
    title: 'Literature Expert',
    icon: require('../assets/xp/lvl-group-5.png'),
  },
  {
    level: 22,
    requiredXP: 4200,
    title: 'Book Sage',
    icon: require('../assets/xp/lvl-group-5.png'),
  },
  {
    level: 23,
    requiredXP: 4800,
    title: 'Reading Maestro',
    icon: require('../assets/xp/lvl-group-5.png'),
  },
  {
    level: 24,
    requiredXP: 5400,
    title: 'Story Weaver',
    icon: require('../assets/xp/lvl-group-5.png'),
  },
  {
    level: 25,
    requiredXP: 6000,
    title: 'Book Artisan',
    icon: require('../assets/xp/lvl-group-6.png'),
  },
  {
    level: 26,
    requiredXP: 6800,
    title: 'Reading Oracle',
    icon: require('../assets/xp/lvl-group-6.png'),
  },
  {
    level: 27,
    requiredXP: 7600,
    title: 'Literature Sage',
    icon: require('../assets/xp/lvl-group-6.png'),
  },
  {
    level: 28,
    requiredXP: 8400,
    title: 'Book Luminary',
    icon: require('../assets/xp/lvl-group-6.png'),
  },
  {
    level: 29,
    requiredXP: 9400,
    title: 'Reading Prodigy',
    icon: require('../assets/xp/lvl-group-6.png'),
  },
  {
    level: 30,
    requiredXP: 10400,
    title: 'Story Architect',
    icon: require('../assets/xp/lvl-group-7.png'),
  },
  {
    level: 31,
    requiredXP: 11600,
    title: 'Book Guardian',
    icon: require('../assets/xp/lvl-group-7.png'),
  },
  {
    level: 32,
    requiredXP: 12800,
    title: 'Reading Paragon',
    icon: require('../assets/xp/lvl-group-7.png'),
  },
  {
    level: 33,
    requiredXP: 14200,
    title: 'Literature Virtuoso',
    icon: require('../assets/xp/lvl-group-7.png'),
  },
  {
    level: 34,
    requiredXP: 15600,
    title: 'Book Mystic',
    icon: require('../assets/xp/lvl-group-7.png'),
  },
  {
    level: 35,
    requiredXP: 17200,
    title: 'Reading Sovereign',
    icon: require('../assets/xp/lvl-group-8.png'),
  },
  {
    level: 36,
    requiredXP: 18800,
    title: 'Story Legend',
    icon: require('../assets/xp/lvl-group-8.png'),
  },
  {
    level: 37,
    requiredXP: 20400,
    title: 'Book Grandmaster',
    icon: require('../assets/xp/lvl-group-8.png'),
  },
  {
    level: 38,
    requiredXP: 22000,
    title: 'Reading Illuminator',
    icon: require('../assets/xp/lvl-group-8.png'),
  },
  {
    level: 39,
    requiredXP: 23600,
    title: 'Literature Oracle',
    icon: require('../assets/xp/lvl-group-8.png'),
  },
  {
    level: 40,
    requiredXP: 25200,
    title: 'Book Transcendent',
    icon: require('../assets/xp/lvl-group-9.png'),
  },
  {
    level: 41,
    requiredXP: 26800,
    title: 'Reading Exemplar',
    icon: require('../assets/xp/lvl-group-9.png'),
  },
  {
    level: 42,
    requiredXP: 28400,
    title: 'Story Sovereign',
    icon: require('../assets/xp/lvl-group-9.png'),
  },
  {
    level: 43,
    requiredXP: 30000,
    title: 'Book Luminary',
    icon: require('../assets/xp/lvl-group-9.png'),
  },
  {
    level: 44,
    requiredXP: 31600,
    title: 'Reading Sage',
    icon: require('../assets/xp/lvl-group-9.png'),
  },
  {
    level: 45,
    requiredXP: 33200,
    title: 'Literature Master',
    icon: require('../assets/xp/lvl-group-10.png'),
  },
  {
    level: 46,
    requiredXP: 34800,
    title: 'Book Champion',
    icon: require('../assets/xp/lvl-group-10.png'),
  },
  {
    level: 47,
    requiredXP: 36400,
    title: 'Reading Elite',
    icon: require('../assets/xp/lvl-group-10.png'),
  },
  {
    level: 48,
    requiredXP: 38000,
    title: 'Story Supreme',
    icon: require('../assets/xp/lvl-group-10.png'),
  },
  {
    level: 49,
    requiredXP: 39200,
    title: 'Book Legend',
    icon: require('../assets/xp/lvl-group-10.png'),
  },
  {
    level: 50,
    requiredXP: 40000,
    title: 'Grand Master Reader',
    icon: require('../assets/xp/lvl-group-10.png'),
  },
];

export function getXPLevelInfo(xp: number): XPLevelInfo {
  // Find the highest level where the user has enough XP
  const currentLevel = _.findLast(
    XP_LEVEL_DEFINITIONS,
    (def) => xp >= def.requiredXP,
  );

  // Get the next level definition if it exists
  const nextLevel =
    XP_LEVEL_DEFINITIONS[currentLevel.level + 1] ?? currentLevel;

  // Calculate progress within current level
  const xpProgress = xp - currentLevel.requiredXP;
  const xpForNextLevel = nextLevel.requiredXP - currentLevel.requiredXP;
  const progress = xpForNextLevel > 0 ? xpProgress / xpForNextLevel : 1;

  return {
    level: currentLevel.level,
    title: currentLevel.title,
    icon: currentLevel.icon,
    xpGainedInLevel: xpProgress,
    xpLeftToNextLevel: xpForNextLevel - xpProgress,
    xpRequiredForNextLevel: xpForNextLevel,
    progressInLevel: Math.min(1, Math.max(0, progress)),
  };
}
